module.exports = __webpack_public_path__ + "static/media/038.98f3eb40.jpg";